<template>
    <v-dialog v-model="archiveDialog.open" max-width="500" persistent>
        <v-card>
            <v-card-title class="headline">{{ $t(archiveDialog.title) }}</v-card-title>
            <v-card-text><b>{{ $t(archiveDialog.description) }}</b></v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="archiveDialog.open = false">
                    {{ $t("general.cancel") }}
                </v-btn>
                <v-btn color="error" text @click="$emit('triggerToggleArchive', item)" data-cy="archiveEvent">{{
                    $t(archiveDialog.button) }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: ["archiveDialog", "item"],
};
</script>
